import workouts from '../data/workouts'
export default {
  workouts,
  uid: '',
  unlockedWorkouts: [],
  userCalendar: []
}
